import { GetCoinListTypeEnum } from '@/enums/businessEnum';
import CacheEnum from '@/enums/cacheEnum';
import { useLocalStorage } from '@/hooks/useStorage';
import { getTradingSymbolsApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';
import { useModel } from '@umijs/max';
import { useUpdateEffect } from 'ahooks';

export interface TradePair {
  alias: string;
  baseId: string;
  baseSymbol: string;
  coin: string[];
  commission: number;
  commissionType: number;
  createTime: number;
  exchange: string;
  exchangeId: string;
  exchangeSymbol: string;
  id: string;
  imgUrl: string | null;
  name: string;
  priceAccuracy: number;
  remark: string | null;
  sort: number;
  startTime: number | null;
  status: number;
  symbol: string;
  symbolId: string;
  type: number;
  visible: number;
}

export default () => {
  const { sendMsg } = useModel('socket');
  //选中币种
  const [localCoin, setLocalCoin] = useLocalStorage<TradePair>({
    key: CacheEnum.APP_LOCAL_COIN,
  });

  // 异步获取合约缓存进本地
  const { data: coinListData = [] as any, run: getTheListOfCoins } = useReq(
    getTradingSymbolsApi,
    {
      manual: true,
      cacheKey: CacheEnum.LIST_OF_STOCK_TYPES,
      formatResult: (res: any) => {
        const { list } = res?.data || [];
        return list ?? [];
      },
      onSuccess: (res: any) => {
        // 成功获取数据后，更新本地存储和发送订阅消息
        if (res?.[0]) {
          if (!localCoin) {
            setLocalCoin(res[0]);
          }
          sendMsg(
            `{"type":"SUB","data": ${JSON.stringify(
              res?.map((i: { symbol: any }) => i?.symbol),
            )}}`,
          );
        }
      },
    },
  );

  // 获取用户信息
  const { user } = useModel('user');
  // 监听用户信息变化
  useUpdateEffect(() => {
    if (user?.id) {
      getTheListOfCoins({
        page: 1,
        pageSize: 10,
        type: GetCoinListTypeEnum.COIN,
      });
    }
  }, [user]);

  return {
    coinListData,
    localCoin,
    setLocalCoin,
  };
};
